module.exports = __webpack_public_path__ + "static/media/br.a102e563.svg";